import type { PlotPlaneThemeConfig } from '@/src/modules/experiences/wedding/plotPlane/plotPlaneTypes';

const BASE = '/assets/templates/marigold-haveli-journey';

export const marigoldHaveliJourneyTheme: PlotPlaneThemeConfig = {
  templateId: 'marigold-haveli-journey',
  assetBase: BASE,
  palette: {
    bg: '#fff9f0',
    bgDeep: '#ffedd5',
    primary: '#c2410c',
    accent: '#0d9488',
    gold: '#f59e0b',
    text: '#431407',
    textMuted: '#78716c',
    panel: 'rgba(255, 249, 240, 0.88)',
    panelBorder: 'rgba(234, 88, 12, 0.35)',
  },
  particle: 'marigold-petals',
  typography: {
    display: '"Cormorant Garamond", "Playfair Display", Georgia, serif',
    body: 'Inter, system-ui, sans-serif',
  },
  beats: [
    {
      id: 'haveli-jali',
      navLabel: 'Haveli jali',
      depth: 0,
      backdrop: `${BASE}/jali.svg`,
    },
    {
      id: 'courtyard-hero',
      navLabel: 'Courtyard hero',
      depth: 520,
      backdrop: `${BASE}/courtyard-day.svg`,
    },
    {
      id: 'mandap-room',
      navLabel: 'Mandap room',
      depth: 1040,
      backdrop: `${BASE}/jali.svg`,
    },
    {
      id: 'function-verandah',
      navLabel: 'Function verandah',
      depth: 1560,
      backdrop: `${BASE}/courtyard-day.svg`,
    },
    {
      id: 'rsvp-courtyard',
      navLabel: 'RSVP courtyard',
      depth: 2080,
      backdrop: `${BASE}/jali.svg`,
    },
  ],
};
